export enum NotificationLevelType {
    Neutral = 'Neutral',
    Warning = 'Warning',
    Alert = 'Alert',
}
